import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';

import './Favorites.scss';

import { Button, LazyLoad, RouterLink } from '../../components/ui';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';

import favoriteSlice from '../../store/slices/favorites.slice';
import orderSlice from '../../store/slices/order.slice';
import { getFavorites } from '../../store/slices/favorites.slice';

import Frame from '../../store/interfaces/frame.interface';

const Favorites = () => {
  const { favorites } = useSelector(getFavorites);
  const dispatch = useDispatch();
  const [removeFavorite, setRemoveFavorite] = useState(null);
  const [show, setShow] = useState(false);

  const handleFrameClick = async (frame: Frame) => {
    dispatch(orderSlice.actions.setFrame(frame));
  };

  const handleRemoveFavorite = () => {
    dispatch(favoriteSlice.actions.removeFavorite(removeFavorite));
    setShow(false);
  };

  const handleClose = () => {
    setRemoveFavorite(null);
    setShow(false);
  };

  const handleShow = (e: React.MouseEvent<HTMLElement>, index: any) => {
    e.preventDefault();
    setRemoveFavorite(index);
    setShow(true);
  };

  return (
    <div className="favorites">
      <Breadcrumbs path="My favorites" background="favorites"></Breadcrumbs>
      <div className="wrapper">
        {favorites?.length === 0 ? (
          <h1 className="text heading">You have no items in your Favorites.</h1>
        ) : (
          <div className="content">
            <ul className="eyeglasses-list">
              {favorites.map((favorite, index) => (
                <li key={`frame-${favorite.id}`}>
                  <a
                    href="/"
                    className="close-btn"
                    onClick={e => {
                      handleShow(e, index);
                    }}
                  ></a>
                  <RouterLink
                    path={`/eyeglasses/${favorite.modelCode}`}
                    click={async () => await handleFrameClick(favorite)}
                  >
                    <LazyLoad imgSrc={favorite.previews[0]} imgAlt="Nice" />
                    <div className="eyeglasses-info-container">
                      <h3>{favorite.modelName}</h3>
                      <span>${favorite.price.toFixed(2)}</span>
                    </div>
                    <div className="tools">
                      <Button>View Details</Button>
                    </div>
                  </RouterLink>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Modal show={show} backdrop="static" onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>visionhub.confirm.removefavorite?</Modal.Body>
        <Modal.Footer>
          <Button click={handleClose}>Cancel</Button>
          <Button className="button secondary-button" click={handleRemoveFavorite}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default Favorites;
